import { route, tag, type PageTour } from '../pageTour';

export const alertDetailTour: PageTour = {
  id: 'page-alert-detail',
  version: 1,
  title: 'Alert Details',
  summary: 'One alert in full: snapshot, clip, timeline and actions.',
  match: route('/alerts/:id'),
  steps: [
    {
      target: tag('alert-detail-evidence'),
      title: 'What was seen',
      description:
        'The snapshots and recorded video from the moment the alert fired, plus what triggered it.',
      side: 'right',
    },
    {
      target: tag('alert-detail-details'),
      title: 'Alert details',
      description: 'The alert name, camera, time and any notes added when it was resolved or cancelled.',
      side: 'left',
    },
    {
      target: tag('alert-detail-activity'),
      title: 'History and comments',
      description:
        'See who acknowledged, assigned or resolved this alert and when. Use the Comments tab to leave a note for your team.',
      side: 'left',
    },
    {
      target: tag('alert-detail-actions'),
      title: 'Take action',
      description:
        'Acknowledge, assign, resolve or mark the alert as a false positive. The letter on each button is its keyboard shortcut.',
      side: 'top',
    },
    {
      target: tag('alert-detail-back'),
      title: 'Back to alerts',
      description: 'Return to the Alert List when you are done here.',
      side: 'bottom',
    },
  ],
};
